import * as React from 'react';
import * as styles from './ImageViewer.css';
import { IComposerImage } from '../../interfaces/IComposerImage';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { IAIcon } from '../icon/Icon';
import { Environment } from '../../services/Environment';
import { Helper } from '../../Helper';
import { IEnvironment } from '../../interfaces/IEnvironment';

export interface IImageViewerProps {
  token: string;
  environment: IEnvironment;
  tenant: string;
  images: IComposerImage[];
  index: number;
  isMobile: boolean;
  close: () => void;
}

export interface IImageViewerState {
  index: number;
}

export class IAImageViewer extends React.Component<IImageViewerProps, IImageViewerState> {

  constructor(props: IImageViewerProps) {
    super(props);
    this.state = {
      index: props.index + 1
    }
  }

  public componentWillReceiveProps(props: IImageViewerProps): void {
    if (props.index !== this.props.index) {
      this.setState({ index: props.index + 1 });
    }
  }

  public render(): JSX.Element {
    const images = [];
    if (this.props.images) {
      this.props.images.forEach((image: IComposerImage, index) => {
        const imageUrl = Helper.getImageFromApiWhenOutsideSharepoint(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, image.url, image.modified, "Full");
        images.push(
          <div
            key={`IA_imageViewer_${index}`}
            style={{
              position: "relative",
              float: "left",
              textAlign: "center"
            }}
            onClick={() => this.props.close()}
          >
            <div className={styles.IA_imageViewerSpinner}>
              <IAIcon
                title="Spinner"
                size={20}
                color={"#999999"}
              />
            </div>
            <div
              className={styles.IA_imageViewerImage}
              style={{
                backgroundImage: (index + 1 === this.state.index) ? "none" : `url(${imageUrl})`
              }}
            />
            {(index + 1 === this.state.index) &&
              <TransformComponent
                wrapperStyle={{
                  position: "absolute"
                }}
              >
                <div
                  className={styles.IA_imageViewerImage}
                >
                  <img
                    src={imageUrl}
                    alt={image.altText ?? ""}
                  />
                </div>
              </TransformComponent>
            }
            {image.altText &&
              <div className={styles.IA_imageViewerImageAltTextWrapper}>
                <div className={styles.IA_imageViewerImageAltText}>{image.altText}</div>
              </div>
            }
          </div>
        );
      });
    }
    return images && images.length > 0 ? (
      <div
        id="IA_imageViewer"
        className={styles.IA_imageViewer}
      >
        <div className={styles.IA_imageViewerBackground} />
        <div
          className={styles.IA_imageViewerContainer}
          style={{
            width: `${this.props.images.length * 100}vw`,
            left: -window.innerWidth * (this.state.index - 1)
          }}
        >
          <TransformWrapper
            initialScale={1}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <React.Fragment>
                <div className={styles.IA_navigation}>
                  <div
                    className={styles.IA_previous}
                    style={{
                      opacity: this.state.index > 1 ? 1 : 0
                    }}
                    onClick={() => this.state.index > 1 ? this.setState({ index: this.state.index - 1 }, () => resetTransform()) : {}}
                  >
                    <IAIcon
                      url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Left/SVG/ic_fluent_chevron_left_48_regular.svg"
                      size={25}
                      color={"white"}
                      onClick={() => { }}
                    />
                  </div>
                  <div
                    className={styles.IA_next}
                    style={{
                      opacity: this.props.images.length > this.state.index ? 1 : 0
                    }}
                    onClick={() => this.props.images.length > this.state.index ? this.setState({ index: this.state.index + 1 }, () => resetTransform()) : {}}
                  >
                    <IAIcon
                      url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Right/SVG/ic_fluent_chevron_right_48_regular.svg"
                      size={25}
                      color={"white"}
                      onClick={() => { }}
                    />
                  </div>
                </div>
                {images}
                {!this.props.isMobile &&
                  <div className={styles.IA_imageViewerToolbox}>
                    <div
                      className={styles.IA_imageViewerToolboxButton}
                      onClick={() => zoomIn()}
                    >
                      <IAIcon
                        title={"ZoomIn"}
                        size={25}
                        color={"white"}
                        onClick={() => { }}
                      />
                    </div>
                    <div
                      className={styles.IA_imageViewerToolboxButton}
                      onClick={() => zoomOut()}
                    >
                      <IAIcon
                        title={"ZoomOut"}
                        size={25}
                        color={"white"}
                        onClick={() => { }}
                      />
                    </div>
                    <div
                      className={styles.IA_imageViewerToolboxButton}
                      onClick={() => resetTransform()}
                    >
                      <IAIcon
                        title={"Restart"}
                        size={25}
                        color={"white"}
                        onClick={() => { }}
                      />
                    </div>
                    <div
                      className={styles.IA_imageViewerToolboxButton}
                      onClick={() => this.props.close()}
                    >
                      <IAIcon
                        title={"Close"}
                        size={25}
                        color={"white"}
                        onClick={() => { }}
                      />
                    </div>
                    <div
                      className={styles.IA_imageViewerToolboxButton}
                      onClick={() => {
                        window.open(this.props.images[this.state.index - 1].url, "_blank");
                      }}
                    >
                      <IAIcon
                        title={"Download"}
                        size={25}
                        color={"white"}
                        onClick={() => { }}
                      />
                    </div>
                  </div>
                }
              </React.Fragment>
            )}
          </TransformWrapper>
        </div>
      </div>
    ) : (<div></div>);
  }
}